<div class="modal">
  <h2 class="h2 mb-0 align-center align-left--ps">Attach File to Response</h2>
  <div class="ml-0 mr-0 pl-0 pr-0">
    <app-file-selector [(file)]="file"></app-file-selector>
  </div>
  <div class="d-flex--ps flexJustify-between mt-0125">
    <button class="btn btn--blue d-block w-100 w-auto--ps mb-0100 mb-0--ps"
            type="button"
            [appButtonSpinner]="isSaving"
            [disabled]="isSaving || !file"
            (click)="onSaveClick()">Save</button>
    <button class="btn btn--whiteRed d-block w-100 w-auto--ps"
            type="button"
            [disabled]="isSaving"
            (click)="close()">Cancel</button>
  </div>
</div>
